// extracted by mini-css-extract-plugin
module.exports = {"billing-reminder":"_1MJr7I6V3wbfa5xM4a7lWw","notification-expire":"_1FIUHU70C5ME-Eqqzkgmu8","text-notif":"_1UYVawAhbEQ7FecVnDFJ0u","disable-link":"_2GNlEntXVn_MokTCyQbkG1"};